// @ts-nocheck
import { SparklineManager, Sparkline } from "../vis/Sparklines";
import "regenerator-runtime/runtime";
import GuiHandler from "./GuiHandler";
import DataHandler from "../data/DataHandler";
import MapHandler from "../map/MapHandler";
import {
  Indicator,
  IndicatorOverview,
  IndicatorOverviewObject,
  ValidateWithGUISettings,
} from "../../interfaces/resource.interfaces";
import {
  Feature,
  FeatureCollection,
  GenericJavaScriptObject,
} from "../../interfaces/map.interfaces";
import IndicatorParameterHandler from "./IndicatorParameterHandler";

export default class IndicatorHandler {
  #guihandler: GuiHandler;
  #datahandler: DataHandler;
  #maphandler: MapHandler;
  #indiparhandler: any;
  #indicators!: IndicatorOverview;
  #aggregatedDataByYear = {};

  constructor(
    guihandler: GuiHandler,
    datahandler: DataHandler,
    maphandler: MapHandler
  ) {
    this.#guihandler = guihandler;
    this.#datahandler = datahandler;
    this.#maphandler = maphandler;
    this.#initUI();
  }

  async #initUI() {
    const that = this;
    $("#indicatorghost").data("obj", this);
    that.#indiparhandler = new IndicatorParameterHandler(
      that.#guihandler,
      that
    );
    const data = await this.#datahandler.requestIndicatorOverview();
    that.#indicators = data;
    that.#createIndicatorMenus();

    document.addEventListener("refreshUI", () => {
      that.processIndicators();
    });
  }

  #convertAccessibleIndicators(accessibleIndicators: Indicator[]) {
    return new Map(accessibleIndicators.map((ind) => [ind.name, ind]));
  }

  async #createIndicatorMenus() {
    const that = this;
    const accessParameters = await that.#guihandler.getAccessParameter();
    const accessibleIndicators = this.#convertAccessibleIndicators(
      accessParameters.indicators
    );

    const indicatorCategories = $("#indicatorCategories");
    indicatorCategories.empty();

    const defaultValues = {
      People: "people_number_abs",
      //Buildings: "buildings_type" // this can take a lot of time to load
    };
    // Attach event handlers
    indicatorCategories
      .on("mousedown", "option", optionSelectCallback)
      .on("touchstart", "option", optionSelectCallback);
    let defaultSelections = [];

    Object.keys(this.#indicators).forEach((category) => {
      // logic for filtering indicators based on the user access rights
      let theseIndicators = this.#indicators[category].filter((indicator) =>
        accessibleIndicators.has(indicator.name)
      );

      // build the menu
      if (theseIndicators.length > 0) {
        let displayCategory = theseIndicators[0].displaycategory;
        indicatorCategories.append(
          `<div id="indicators${category}">
            <span class="indicatorHeading">Indikatoren "${displayCategory}"</span><br>
            <select multiple></select>
          </div>`
        );

        theseIndicators.forEach((indicator) => {
          let opt = $(
            `<option minimumYear="${indicator.minyear}" value="${indicator.name}">${indicator.displayname}</option>`
          ).data("meta", indicator);
          $(`#indicators${category} select`).append(opt);

          // Queue default selections for later processing
          if (
            defaultValues[category] &&
            defaultValues[category] === indicator.name
          ) {
            defaultSelections.push(opt);
          }
        });

        that.#indiparhandler.addIndicatorParameterCategory(
          "#indicatorParametersWrapper",
          category,
          displayCategory
        );
      }
    });

    // Process default selections after all menus are created
    defaultSelections.forEach((opt) => {
      optionSelectCallback({ currentTarget: opt });
    });

    function optionSelectCallback(e) {
      const opt = $(e.currentTarget);
      const currentlyselected = opt.hasClass("customSelectedOption");
      const indicatorMeta = opt.data("meta");

      $("#indicatorCategories option.customSelectedOption")
        .filter(
          (_, elem) =>
            $(elem).data("meta").viscategory === indicatorMeta.viscategory
        )
        .removeClass("customSelectedOption");

      that.#indiparhandler.hideDeprecatedParameters(indicatorMeta.category);

      if (!currentlyselected) {
        opt.addClass("customSelectedOption");
        that.#indiparhandler.setParameters(indicatorMeta);
        that.#indiparhandler.toggleParameterCategory(indicatorMeta, true);
        that.processIndicators([indicatorMeta]);
      } else {
        //deselect
        //opt.removeClass("customSelectedOption");
        that.#indiparhandler.toggleParameterCategory(indicatorMeta, false);
        that.#maphandler.removeIndicator(
          indicatorMeta.category === "Buildings"
        );
      }
      e.preventDefault();
    }
  }


  processIndicators(indicatorMetaArray: any[] = []) {
    //if indicatorMetaArray is provided, it will include a single selected indicatorMeta, after interacting with one select menu
    const that = this;
    if (indicatorMetaArray.length === 0) {
      //if a different time or municipality is selected
      $("#indicatorCategories option.customSelectedOption").each((_, elem) => {
        indicatorMetaArray.push($(elem).data("meta"));
      });
    }
    indicatorMetaArray.forEach(async (meta) => {
      const currentParameters = that.#indiparhandler.getParameterValues(meta);
      var settings = {
        indicator: {
          name: meta.name,
          parameters: currentParameters,
          viscategory: meta.viscategory,
          minyear: meta.minyear,
          sparklines: this.#maphandler.showSparklines(),
        },
      };
      var yearFrom = $("#year-from").text().trim();
      var yearUntil = $("#year-until").text().trim();
      meta.aggregation = this.#guihandler.getAggregation();
      if (yearFrom < meta.minyear) {
        $("#indicatorCategories option.customSelectedOption").each(
          (_, elem) => {
            if ($(elem).data("meta").name === meta.name) {
              $(elem).removeClass("customSelectedOption");
              that.#indiparhandler.toggleParameterCategory(meta, false);
            }
          }
        );
        this.#maphandler.removeIndicator();
      }

      $("#indicatorsettingsghost").data("settings", settings);
      $("#indicatorMetaGhost").data("indicatorMeta", indicatorMetaArray);
      if (yearFrom && !yearUntil) {
        let [featureCollection, aggregatedData] = await Promise.all([
          this.#datahandler.requestAggregatedIndicators(settings),
          this.fetchSparklines(settings, meta),
        ]);

        aggregatedData =
          meta.viscategory === "Squares" && settings.indicator.sparklines
            ? aggregatedData
            : {};

        featureCollection[0].features.forEach((feature) => {
          const id = feature.properties.id;
          if (aggregatedData && aggregatedData[id]) {
            feature.properties.sparklineSVG = aggregatedData[id].sparklineSVG;
            feature.properties.sparklineDetailedSVG =
              aggregatedData[id].sparklineDetailedSVG;
          }
        });

        if (this.validateWithGUI(settings)) {
          this.#maphandler.visualizeIndicator(featureCollection[0], meta);
        }
      } else if (yearFrom && yearUntil) {
        settings.indicator.parameters.p_yearUntil = yearUntil;

        if (settings.indicator.viscategory === "Squares") {
          Promise.all([
            new Promise<FeatureCollection>((resolve, reject) => {
              this.#datahandler.requestChangeIndicator(
                settings,
                (featureCollection: FeatureCollection[]) => {
                  resolve(featureCollection[0]);
                }
              );
            }),
            new Promise<GenericJavaScriptObject<any> | undefined>(
              (resolve, reject) => {
                if (
                  meta.viscategory === "Squares" &&
                  settings.indicator.sparklines
                ) {
                  this.fetchSparklines(settings, meta).then(
                    (aggregatedData) => {
                      resolve(aggregatedData);
                    }
                  );
                } else {
                  resolve({});
                }
              }
            ),
          ]).then(([featureCollection, aggregatedData]) => {
            featureCollection.features.forEach((feature) => {
              if (!feature.properties) {
                return;
              }
              const id = feature.properties.id;
              if (aggregatedData && aggregatedData[id]) {
                feature.properties.sparklineSVG =
                  aggregatedData[id].sparklineSVG;
                feature.properties.sparklineDetailedSVG =
                  aggregatedData[id].sparklineDetailedSVG;
              }
            });

            if (this.validateWithGUI(settings)) {
              this.#maphandler.visualizeIndicator(featureCollection, meta);
            }
          });
        }
      }
    });
  }



  validateWithGUI(settings: ValidateWithGUISettings) {
    var selectedGUI = $("#indicatorCategories option.customSelectedOption");
    var foundMatch = false;

    //TODO: Fix in meta variable
    if (settings.indicator.parameters.p_yearUntil) {
      delete settings.indicator.parameters.p_yearUntil;
    }

    selectedGUI.each((_, elem) => {
      var meta = $(elem).data("meta");

      if (meta.name == settings.indicator.name) {
        if (
          JSON.stringify(this.#indiparhandler.getParameterValues(meta)) ==
          JSON.stringify(settings.indicator.parameters)
        ) {
          foundMatch = true;
          return false; // Breaks the loop when a match is found
        }
      }
    });

    return foundMatch;
  }

  getAggregatedDataByYear() {
    return this.#aggregatedDataByYear;
  }

  updateIndicatorSelection(yearFrom: number, yearUntil: number) {
    var container = $("#indicatorCategories");
    var buildingsContainer = $("#indicatorsBuildings");
    var customSelectedOption = container.find(".customSelectedOption");

    container.find("select").each(function () {
      $(this)
        .find("option")
        .each(function () {
          const minYearFromUI = $(this).attr("minimumyear");
          if (minYearFromUI && typeof minYearFromUI === typeof "string") {
            const minYear: number = parseInt(minYearFromUI, 10);

            if (minYear > yearFrom) {
              $(this).attr("disabled", "disabled");
            } else {
              $(this).removeAttr("disabled");
            }
          }
        });
    });

    if (yearFrom && yearUntil) {
      $(buildingsContainer).find("select").attr("disabled", "disabled");
      $(buildingsContainer)
        .find("select option")
        .removeClass("customSelectedOption");
      this.#maphandler.removeIndicator(true);
    } else {
      $(buildingsContainer).find("select").removeAttr("disabled");
    }
  }

  async fetchSparklines(
    settings: ValidateWithGUISettings,
    meta: IndicatorOverviewObject
  ): Promise<GenericJavaScriptObject<any> | undefined> {
    var yearFrom = $("#year-from").text().trim();
    var yearUntil = $("#year-until").text().trim();

    if (meta.viscategory === "Squares" && $("#mapghost").data("o").showSparklines()) {
      var aggregatedDataByYear: GenericJavaScriptObject<any> = {};
      if (settings.indicator.parameters.p_yearUntil)
        delete settings.indicator.parameters.p_yearUntil;
      const years = await this.#datahandler.requestIndicatorMultipleYears(
        settings
      );
      years.forEach((yearObj) => {
        yearObj.data[0].features.forEach((feature: Feature) => {
          const id = feature.properties.id;
          if (!aggregatedDataByYear[id]) {
            aggregatedDataByYear[id] = [];
          }
          const year = yearObj.year;
          aggregatedDataByYear[id].push({
            indicator: feature.properties.indicator,
            year: year,
          });
        });
      });
      var yearSelection = yearUntil ? [yearFrom, yearUntil] : [yearFrom];
      SparklineManager.resetGlobals();

      Object.entries(aggregatedDataByYear).forEach(([id, indicators]) => {
        const sparkline = new Sparkline(indicators, yearSelection);
        indicators.sparkline = sparkline;
        indicators.sparklineSVG = sparkline.getSVG();
      });

      Object.entries(aggregatedDataByYear).forEach(([id, indicators]) => {
        indicators.sparklineDetailedSVG =
          indicators.sparkline.createDetailedSVG();
      });
      this.#aggregatedDataByYear = aggregatedDataByYear;
      return aggregatedDataByYear;
    }
  }
}
